import { GET_WIDGET_DATA_ERROR } from '@modules/analytics/common/constants';

export const getWidgetDataErrorText = (id: number | string): string => {
  return `Виджет ${id}: ${GET_WIDGET_DATA_ERROR}`;
};
